import { parseISO, isValid, format as fnsFormat, formatISO } from 'date-fns';

export { parseISO, isValid } from 'date-fns';

export const mkdate = (input) => {
  if (isValid(input)) {
    return input;
  }

  const dt = parseISO(input);
  return isValid(dt) ? dt : null;
};

export const format = (input, pattern, defaultValue = '') => {
  const dt = mkdate(input);

  if (!dt) {
    return defaultValue;
  }

  if (!pattern) {
    return formatISO(dt);
  }

  return fnsFormat(dt, pattern);
};

const DOB_REGEX = /^(\d{2})\/(\d{2})\/(\d{4})$|^(\d{4})-(\d{2})-(\d{2})$/;

export function isValidDobString(value) {
  if (typeof value !== 'string') return false;
  const m = value.trim().match(DOB_REGEX);
  if (!m) return false;
  const month = parseInt(m[1] ?? m[5], 10);
  const day = parseInt(m[2] ?? m[6], 10);
  const year = parseInt(m[3] ?? m[4], 10);
  if (year < 1900) return false;
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;
  return true;
}
